define( function() {
	"use strict";

	return ( /^margin/ );
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/css/var/rmargin.js
// module id = 1837
// module chunks = 37